import styled from '@emotion/styled'
import { device, space, useLockBodyScroll, color } from '@ticketswap/solar'
import Menu from './Menu'

const ScrollContainer = styled.div`
  position: absolute;
  inset: 0;
  overflow-y: scroll;
  padding-block: ${space[64]} ${space[16]};
  padding-inline: ${space[16]};
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    display: none;
  }
`

const Container = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${color.background};

  &::after {
    content: '';
    position: absolute;
    inset-block-start: 0;
    inset-inline: 0;
    height: ${space[64]};
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 100%
    );

    [data-theme='dark'] & {
      background-image: linear-gradient(
        to bottom,
        rgba(0, 19, 25, 1) 0%,
        rgba(0, 19, 25, 1) 50%,
        rgba(0, 19, 25, 0) 100%
      );
    }
  }

  @media ${device.tablet} {
    display: none;
  }
`

const Overlay = ({ type }) => {
  useLockBodyScroll()

  return (
    <Container>
      <ScrollContainer>
        <Menu type={type} />
      </ScrollContainer>
    </Container>
  )
}

export default Overlay
